module.exports = __webpack_public_path__ + "static/img/11.02048e4f.jpg";